import { useMemo } from 'react'
import { useSignUpStepperStore } from 'redesign/store'
import { shallow } from 'zustand/shallow'

export const useSignUpStepper = () => {
    const { _step, _setStep, _size, _setSize } = useSignUpStepperStore(
        state => ({
            _step: state.step,
            _setStep: state.setStep,
            _size: state.size,
            _setSize: state.setSize,
        }),
        shallow,
    )

    const size = useMemo(() => _size, [_size])
    const step = useMemo(() => _step, [_step])

    const setStepValue = (value: number) => {
        _setStep(value)
    }

    const setStepSize = (value: number) => {
        _setSize(value)
    }

    const setStep = (stepValue: number, sizeValue: number) => {
        _setStep(stepValue)
        _setSize(sizeValue)
    }

    return {
        step,
        size,
        setStepValue,
        setStepSize,
        setStep,
    }
}
